export default "__VITE_ASSET__632e8597__"